(ns ui.editor2.defaults)

(def defaults
  (let [timeline-min-zoom 30
        timeline-max-zoom 200
        composition-min-zoom 0.5
        composition-max-zoom 5
        slide-duration 15.0
        design-width 1080
        design-height 1920
        window-width #?(:cljs js/window.innerWidth
                        :clj design-width)
        window-height #?(:cljs js/window.innerHeight
                         :clj design-height)
        ]
    {:design/width design-width
     :design/height design-height
     :timeline/min-zoom timeline-min-zoom
     :timeline/max-zoom timeline-max-zoom
     :timeline/snapping-px 10
     :pixel-per-second (min (max (/ window-width
                                    (+ slide-duration 1.0))
                                 timeline-min-zoom)
                            timeline-max-zoom)
     :playhead-position 0 ;; milliseconds
     :status :paused
     :composition-zoom (/ 1.0
                          (/ window-height 1.8 design-height))
     :composition/min-zoom composition-min-zoom
     :composition/max-zoom composition-max-zoom
     :composition/zoom-step 0.2
     :slide/min-duration 1000
     :slide/max-duration (* 60 1000)
     :clip/default-duration 5000}))